//-- Function to validate website name
export const validateWebsiteName = (value: any) => {
  if (!value.trim()) {
    return "This field cannot be empty";
  }
  if (value.length < 8) {
    return "Must be at least 8 characters";
  }
  if (/^[ _]/.test(value)) { 
    return "Cannot start with a space or underscore (_).";
  }
  if (/^\d/.test(value)) {
    return "Cannot start with a number.";
  }
  if (/[ _]$/.test(value)) {
    return "Cannot end with a space or underscore (_).";
  }
  if (/[^A-Za-z0-9_ ]/.test(value)) {
    return "Only letters, numbers, single spaces, and underscores (_) are allowed.";
  }
  if (/\s{2,}/.test(value)) {
    return "Double spaces are not allowed.";
  }

  return "";
};

//-- Function to validate G4 Property ID
export const validateG4PropertyId = (value: any) => {
  if (value === null || value === undefined || value === "") {
    return "G4 Property ID cannot be empty";
  }
  //-- Ensure it's a valid number (digits only)
  if (!/^\d+$/.test(value)) {
    return "G4 Property ID must be a valid number";
  }
  // -- Ensure it's a valid number with between 9 and 10 digits
  if (!/^\d{9,10}$/.test(value)) {
    return "G4 Property ID must be a valid number with between 9 and 10 digits.";
  }
   // Check if all digits are the same (e.g., 111111, 000000, 222222)
   if (/^(\d)\1+$/.test(value)) {
    return "G4 Property ID cannot consist of repeated digits";
  }

   // Check for at least 3 unique digits
  //  const uniqueDigits = new Set(value.toString());
  //  if (uniqueDigits.size < 3) {
  //    return "G4 Property ID must contain at least 3 different digits.";
  //  }
  return "";
};

//-- Function to validate empty or not
export const isEmpty = (value: any) => {
  if (!value) {
    return "This field cannot be empty";
  }
  return "";
};

export const validateAlphaNumeric = (value : any) => {
  if (!value.trim()) {
    return "This field cannot be empty";
  }
  if (!/^[a-z0-9]+$/i.test(value)) {
    return "Must be alphanumeric.";
  }
  return "";
};

export const validateColor = (value : any) => {
  if (!value.trim()) {
    return "This field cannot be empty";
  }
  if (!/^#[0-9A-Fa-f]{6}$/i.test(value)) {
    return "Color must be a valid hex color.";
  }
  return "";
};

export const validateText = (value : any) => {
  if (!value.trim()) {
    return "This field cannot be empty";
  }
  if (value.length < 3) {
    return "Button text must be at least 3 characters.";
  }
  return "";
};

export const validatePercentages = (value : any) => {
  if (value === "" || value === null || value === undefined) {
    return "This field cannot be empty";
  }
  // if (!/^(100|[0-9]{1,2})$/.test(value)) {
  //   return "percentage must be valid number and between 0 and 100.";
  // }
  if (!/^\d+$/.test(value)) {
    return "Only whole numbers (integers) are allowed.";
  }
  if (Number(value) < 0 || Number(value) > 100 || /^0[0-9]+$/.test(value)) {
    return "Percentage must be a valid number between 0 and 100.";
  }
  return "";
};

export const validateLatency = (value : any) => {
  if (value === "" || value === null || value === undefined) {
    return "This field cannot be empty";
  }
  // if (!/^(100|[0-9]{1,2})$/.test(value)) {
  //   return "percentage must be valid number and between 0 and 100.";
  // }
  if (!/^\d+$/.test(value)) {
    return "Only whole numbers (integers) are allowed.";
  }
  if (Number(value) < 1) {
    return "Cannot be zero";
  }
  return "";
};

export const validateMin = (value : any, maxValue : any) => {
  if (value === "" || value === null || value === undefined) {
    return "This field cannot be empty";
  }
  // if (!/^(100|[0-9]{1,2})$/.test(value)) {
  //   return "percentage must be valid number and between 0 and 100.";
  // }
  if (!/^\d+$/.test(value)) {
    return "Only whole numbers (integers) are allowed.";
  }
  if (Number(value) < 1) {
    return "Cannot be zero";
  }
  if(maxValue && value > maxValue){
    return "Must be less than or equal to the Maximal Position."
  }
  return "";
};

export const validateMax = (value : any, minValue : any) => {
  if (value === "" || value === null || value === undefined) {
    return "This field cannot be empty";
  }
  if (!/^-?\d*$/.test(value)) {
    return "";
  }
  if (Number(value) < 1) {
    return "Cannot be zero";
  }
  if(minValue && value < minValue){
    return "Must be greater than or equal to the Minimal Position."
  }
  return "";
};

export const validateUrl = (value: any) => {
  // Allow empty values for optional field
  if (!value || !value.trim()) {
    return "";
  }
  
  const trimmedValue = value.trim();
  
  // Check if URL starts with http:// or https://
  if (!/^https?:\/\//.test(trimmedValue)) {
    return "URL must start with http:// or https://";
  }
  
  // Basic URL pattern validation
  const urlPattern = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
  
  if (!urlPattern.test(trimmedValue)) {
    return "Please enter a valid URL";
  }
  
  // Check for invalid characters
  if (/[\s]/.test(trimmedValue)) {
    return "URL cannot contain spaces";
  }
  
  // Check for proper domain structure (at least one dot after protocol)
  const domainPart = trimmedValue.replace(/^https?:\/\//, '');
  if (!domainPart.includes('.') || domainPart.startsWith('.') || domainPart.endsWith('.')) {
    return "URL must have a valid domain";
  }
  
  return "";
};


